<template>
    <div class="resources d-flex justify-content-around flex-column flex-md-row">
        <div
            class="resource text-center"
            v-for="(item, index) in TRADE_CARDS"
        >
            <b-img
                fluid
                width="100"
                :src="item.image"
                class="resource-image"
            />
            <h1 class="title">
                {{ item.title }}
            </h1>
            <p class="description mx-auto">
                {{ item.description }}
            </p>
        </div>
    </div>
</template>
<script>
import './Resources.scss';

const TRADE_CARDS = [
    {
        image: require('../../../../../assets/images/trade/resource-image-move.png'),
        title: 'Move on Your Timeline',
        description: 'Secure your next home first, then take your time selling your current ' +
            'home so you get full market value.'
    },
    {
        image: require('../../../../../assets/images/trade/resource-image-win.png'),
        title: 'Win in a Competitive Market',
        description: 'Make a more competitive, all-cash offer. Cash offers are 3x more likely to beat financed offers.'
    },
    {
        image: require('../../../../../assets/images/trade/resource-image-contract.png'),
        title: 'Buy with Certainty',
        description: 'Secure your next home even if you haven\'t sold your current home.'
    },
];
export default {
    name: "Resources",
    data() {
        return {
            TRADE_CARDS
        }
    }
}
</script>
